import { getTeamUrl } from "src/react-query/endPoints";
import Token from "src/util/Token";

export async function fetchParentTags(teamId) {
  const token = Token.get();
  const res = await fetch(getTeamUrl(teamId, "/tag/parent"), {
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
  const data = await res.json();
  if (data.success) {
    return data.data.map((tag) => ({
      id: tag.id_tag,
      label: tag.id_tag,
    }));
  }
  return [];
}
